import { IMessageDialog } from "./qp-message-dialog.interface";
import { buttonConfig, IMessageDialogOptions, msgDialogBtnText } from "./qp-message-dialog-options.interface";


export class QpMessageDialogProvider implements angular.IServiceProvider {

    private uibModalConfig: angular.ui.bootstrap.IModalSettings = {
        animation: false,
        keyboard: false,
        backdrop: "static",
        windowClass: "qp-message-dialog-container",
        templateUrl: "qp-message-dialog.html",
        controllerAs: 'vm'
    };

    protected modalInstance?: angular.ui.bootstrap.IModalInstanceService;

    public $get = ["$uibModal", "$q", "$translate",
        function ($uibModal: angular.ui.bootstrap.IModalService, $q: angular.IQService, $translate: angular.translate.ITranslateService) {

            let that: QpMessageDialogProvider = this;

            // todo: ok、retry、cancel有默认样式配置
            let defaultBtnObj: { [key in msgDialogBtnText]: buttonConfig } = {
                "ok": {
                    key: "ok",
                    displayName: $translate.instant("QP-MSG-DIALOG-OK-BTN-TEXT"),
                    style: "contained"
                },
                "retry": {
                    key: "retry",
                    displayName: $translate.instant("QP-MSG-DIALOG-RETRY-BTN-TEXT"),
                    style: "contained"
                },
                "cancel": {
                    key: "cancel",
                    displayName: $translate.instant("QP-MSG-DIALOG-CANCEL-BTN-TEXT"),
                    style: "outlined"
                }
            }

            function handleMsgDialogConfig(cfg: IMessageDialogOptions, defer: angular.IDeferred<string>, iconTipType: string) {
                let uibModalConfig = that.uibModalConfig;

                uibModalConfig.controller = ["$scope", "$uibModalInstance", "$sce",
                    function ($scope, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, $sce) {
                        $scope.title = cfg.title;
                        $scope.contentType = cfg.contentType || "STRING";
                        $scope.content = $scope.contentType === "STRING" ? cfg.content : $sce.trustAsHtml(cfg.content);
                        $scope.code = cfg.code;
                        $scope.msg = cfg.msg;
                        $scope.showLevelIcon = typeof cfg.showLevelIcon == "boolean" ? cfg.showLevelIcon : true;
                        $scope.showCloseBtn = typeof cfg.showCloseBtn == "boolean" ? cfg.showCloseBtn : false;

                        if ($scope.code != undefined || $scope.msg != undefined) {
                            $scope.isCollapsed = true;
                        }

                        $scope.iconTipType = iconTipType;

                        let buttonConfigArray: Array<buttonConfig> = [];

                        if (cfg.buttons && cfg.buttons.length > 0) {
                            for (let i = cfg.buttons.length - 1; i >= 0; i--) {
                                let ele = cfg.buttons[i];

                                // todo: 判断key名
                                if (typeof ele === "string") {
                                    ele = defaultBtnObj[ele.toLowerCase()];
                                    if (typeof ele === "object") {
                                        buttonConfigArray.push(ele);
                                    }
                                }
                                else {
                                    buttonConfigArray.push(ele);
                                }
                            }
                        } else if (cfg.buttons == undefined || cfg.buttons == null || cfg.buttons.length == 0) {
                            let cfg = defaultBtnObj.ok;

                            buttonConfigArray.push(cfg);
                        }

                        $scope.buttonConfigArray = buttonConfigArray;

                        $scope.ok = (key: string) => {
                            $uibModalInstance.close();
                            defer.resolve(key);
                        };

                        $scope.close = () => {
                            $uibModalInstance.close();
                            defer.reject("close");
                        }
                    }];

                return uibModalConfig;
            }

            let qpTipModal: IMessageDialog = {

                error(cfg: IMessageDialogOptions) {
                    let defer = $q.defer<string>();

                    let uibModalCfg = handleMsgDialogConfig(cfg, defer, "error");

                    if (that.modalInstance) {
                        that.modalInstance.close();
                    }

                    that.modalInstance = $uibModal.open({
                        ...uibModalCfg
                    });

                    return defer.promise;
                },

                success(cfg: IMessageDialogOptions) {
                    let defer = $q.defer<string>();

                    let uibModalCfg = handleMsgDialogConfig(cfg, defer, "success");

                    if (that.modalInstance) {
                        that.modalInstance.close();
                    }

                    that.modalInstance = $uibModal.open({
                        ...uibModalCfg
                    });

                    return defer.promise;
                },

                info(cfg: IMessageDialogOptions) {
                    let defer = $q.defer<string>();

                    let uibModalCfg = handleMsgDialogConfig(cfg, defer, "info");

                    if (that.modalInstance) {
                        that.modalInstance.close();
                    }

                    that.modalInstance = $uibModal.open({
                        ...uibModalCfg
                    });

                    return defer.promise;
                },

                warning(cfg: IMessageDialogOptions) {
                    let defer = $q.defer<string>();

                    let uibModalCfg = handleMsgDialogConfig(cfg, defer, "warning");

                    if (that.modalInstance) {
                        that.modalInstance.close();
                    }

                    that.modalInstance = $uibModal.open({
                        ...uibModalCfg
                    });

                    return defer.promise;
                },
            };

            return qpTipModal;
        }];

}




